import { UserModel } from './UserModel';

export class RepeatModel {
    constructor(repeatData) {
        const user = this.getUser(repeatData);

        this._repeat = {
            repeatedId: repeatData.repeated_id,
            type: repeatData.type,
            user,
        };
    }

    get repeat() {
        return this._repeat;
    }

    getUser(repeatData) {
        let user;

        if (repeatData.user) {
            const repeatUserModel = new UserModel(repeatData.user.data);
            user = { ...repeatUserModel.user };
        }

        return user;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/RepeatModel.js